import { Button, Card, Col, Row } from "react-bootstrap";
import { CANCEL,LINK_PARTICIPANT} from "../../util/const";
import LinkPatient from "../LinkPatient";
import { HomePageProps } from "../PatientList";

const LinkAdd = (props:HomePageProps) =>
{
  return (
    <>
      <Card className="mt-3 mb-3" border="secondary" text="white">
        <Card.Header className="fs-5 app-colour">
          <Row>
            <Col>{LINK_PARTICIPANT}</Col>
            <Col className="right">
              <Button type="button" onClick={(e) => props.toggleDisplay(false) } className='fs-6 btn-outline-white'>{CANCEL}</Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="color-text fs-6">
          <LinkPatient toggleDisplay={props.toggleDisplay} />
        </Card.Body>
      </Card>
    </>
  )
}

export default LinkAdd;